import { useMutation } from '@apollo/client';
import { EXECUTE_INSTANCE_COMMAND } from '../../../../gql/executeInstanceCommand';
import { AnyObject } from '../../../../models/types';

export interface InstanceCommandVars {
  url: string;
  args: AnyObject;
  approval?: JSON;
  confirm?: JSON;
}

export { EXECUTE_INSTANCE_COMMAND };

export const useExecuteCommandMutation = () => {
  return useMutation<AnyObject, InstanceCommandVars>(EXECUTE_INSTANCE_COMMAND);
};
